import { render, staticRenderFns } from "./AppSideBar.vue?vue&type=template&id=58577d34&scoped=true&"
import script from "./AppSideBar.vue?vue&type=script&lang=ts&"
export * from "./AppSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./AppSideBar.vue?vue&type=style&index=0&id=58577d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58577d34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
